module.exports = __webpack_public_path__ + "img/8.2940f5f2.png";